import { useOwnProfileQuery } from '@common/cache';
import { useState } from 'react';
import useUserStore from 'store/user.store';

export const useProfile = () => {
  const { user } = useUserStore();
  const profile = useOwnProfileQuery();

  const [tabIndex, setTabIndex] = useState('1');

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setTabIndex(newValue);
  };

  return {
    profile: { ...profile.data!, id: user!.id },
    tabIndex,
    setTabIndex,
    handleChangeTab,
  };
};
